// Lodash
import _property from "lodash/property";

const id = _property("_id");
const address = _property("address");
const businessId = _property("business_id");
const quantity = _property("quantity");
const packageType = _property("package_type");
const description = _property("description");
const packageName = _property("package_name");
const businessName = _property("business_id.user_id.firstName");
const photos = _property("photo");
const price = _property("price");
const location = _property("location");
const latitude = _property("location.coordinates[1]");
const longitude = _property("location.coordinates[0]");
const createdAt = _property("createdAt");
const updatedAt = _property("updatedAt");
const sport = _property("sport_id.name");
const sports = _property("sport_id");
const isActive = _property("is_active");
const hotDeal = _property("hot_deal");

export default {
  id,
  address,
  quantity,
  packageType,
  address,
  description,
  businessId,
  businessName,
  packageName,
  isActive,
  photos,
  price,
  location,
  createdAt,
  updatedAt,
  sport,
  sports,
  latitude,
  longitude,
  hotDeal,
};
